import { createCrudActions } from '../utils/crudGenerator';

const formatGroups = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchGroups,
    create: createGroup,
    update: updateGroup,
    delete: deleteGroups
} = createCrudActions('GROUP', "Grupo", formatGroups);